import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { VideoCounts } from '../../assignment-view.helpers';

/** New · Seen · Done counts for a creator's brief videos. */
@Component({
  selector: 'mbt-video-status-pill',
  template: `
    <span class="inline-flex overflow-hidden rounded-lg border border-(--border-subtle) text-xs font-semibold divide-x divide-(--border-subtle)"
      [attr.aria-label]="counts().new + ' new, ' + counts().seen + ' seen, ' + counts().done + ' done'">
      <span class="flex items-baseline gap-1 px-[9px] py-1"
        [class]="counts().new > 0 ? 'bg-(--app-accent) text-white' : 'bg-(--mba-surface) text-(--fg-3)'">
        <b class="font-(family-name:--font-display) text-base font-extrabold"
          [class]="counts().new > 0 ? 'text-white' : 'text-(--fg-2)'">{{ counts().new }}</b>New</span>
      <span class="flex items-baseline gap-1 bg-(--mba-surface) px-[9px] py-1 text-(--fg-3)">
        <b class="font-(family-name:--font-display) text-base font-extrabold text-(--fg-2)">{{ counts().seen }}</b>Seen</span>
      <span class="flex items-baseline gap-1 bg-(--mba-surface) px-[9px] py-1 text-(--fg-3)">
        <b class="font-(family-name:--font-display) text-base font-extrabold text-(--success)">{{ counts().done }}</b>Done</span>
    </span>
  `,
  host: { style: 'display: contents' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoStatusPill {
  readonly counts = input.required<VideoCounts>();
}
